import {useRef, useState} from 'react';

import {openPopOutWindow} from '@pexip/components';

const POP_OUT_FEATURES = 'width=848,height=480';

export const usePresentationPoppedOut = () => {
    const remotePopOutRef = useRef<Window | null>(null);

    const [isPresentationPoppedOut, setIsPresentationPoppedOut] =
        useState(false);

    const toggleIsPresentationPoppedOut = () => {
        if (isPresentationPoppedOut) {
            setIsPresentationPoppedOut(false);
            return;
        }

        // Staying popped out without a window would strip the presentation from
        // the stage and render it nowhere.
        const popOut = openPopOutWindow(POP_OUT_FEATURES);
        if (!popOut) {
            return;
        }

        remotePopOutRef.current = popOut;
        setIsPresentationPoppedOut(true);
    };

    return {
        isPresentationPoppedOut,
        remotePopOutRef,
        setIsPresentationPoppedOut,
        toggleIsPresentationPoppedOut,
    };
};
